import React, { useState, useRef, useEffect } from "react";

const Dropdown = ({ item, selectedOption, onChange, listOptions }) => {
  const [searchTerm, setSearchTerm] = useState(selectedOption || "");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const dropdownRef = useRef(null);

  // Filter Options based on search term
  const filteredOptions = listOptions.filter((option) =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle clicking outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setHighlightedIndex(-1);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Update searchTerm when selectedOption changes
  useEffect(() => {
    setSearchTerm(selectedOption || "");
  }, [selectedOption]);

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (!isDropdownOpen) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setHighlightedIndex((prev) =>
          prev < filteredOptions.length - 1 ? prev + 1 : prev
        );
        break;
      case "ArrowUp":
        e.preventDefault();
        setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : -1));
        break;
      case "Enter":
        e.preventDefault();
        if (highlightedIndex >= 0 && filteredOptions[highlightedIndex]) {
          handleSelect(filteredOptions[highlightedIndex]);
        }
        break;
      case "Escape":
        setIsDropdownOpen(false);
        setHighlightedIndex(-1);
        break;
    }
  };

  // Handle selecting a reason - FIXED to use dynamic name
  const handleSelect = (value) => {
    setSearchTerm(value);
    onChange({
      target: {
        value: value,
      },
    });

    setIsDropdownOpen(false);
    setHighlightedIndex(-1);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <input
        type="text"
        id={typeof item === "string" ? item : item?._id}
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setIsDropdownOpen(true);
          onChange(e); // This will now pass the correct name
          setHighlightedIndex(-1);
        }}
        onKeyDown={handleKeyDown}
        onFocus={() => {
          setIsDropdownOpen(true);
          setHighlightedIndex(-1);
        }}
        className="mt-1 block w-full rounded-lg px-4 py-2 bg-white text-gray-800 focus:ring-2 focus:ring-blue-500 border border-gray-300 transition-all"
        placeholder="Select an option"
        required
      />

      {/* Dropdown with reason options */}
      {isDropdownOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-[300px] overflow-auto">
          <div className="grid grid-cols-1 gap-1">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <div
                  key={`${option}-${index}`}
                  onClick={() => handleSelect(option)}
                  className={`flex items-center gap-3 p-3 hover:bg-gray-300 cursor-pointer dropdown-item transition-colors ${
                    index === highlightedIndex ? "bg-gray-400" : ""
                  }`}
                >
                  <div className="flex-1">
                    <p className="font-medium text-gray-900">{option}</p>
                  </div>
                </div>
              ))
            ) : (
              <div className="p-3 text-gray-500 text-center">
                No option found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
